// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Skeleton shown while a lazy-loaded dashboard chunk downloads (shell Suspense fallback).
   Mimics a dashboard's layout — title, KPI cards, section blocks — with a shimmer sweep, so
   opening a module fades into placeholder "sections" instead of a bare "Loading..." text flash. */

.mldr {
  min-height: 100%;
  padding: 28px 24px 40px;
  background: var(--bg-primary, #080c14);
  animation: mldr-fade 0.25s ease;
}

@keyframes mldr-fade {
  from { opacity: 0; }
  to   { opacity: 1; }
}

/* Shimmer block base — every placeholder is a .mldr-sk */
.mldr-sk {
  position: relative;
  overflow: hidden;
  background: var(--bg-card, rgba(15, 23, 42, 0.45));
  border: 1px solid var(--border-subtle, rgba(255, 255, 255, 0.04));
  border-radius: 14px;
}
.mldr-sk::after {
  content: "";
  position: absolute;
  inset: 0;
  transform: translateX(-100%);
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(148, 163, 184, 0.10) 45%,
    rgba(148, 163, 184, 0.16) 50%,
    rgba(148, 163, 184, 0.10) 55%,
    transparent 100%
  );
  animation: mldr-shimmer 1.6s ease-in-out infinite;
}
[data-theme="light"] .mldr-sk::after {
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(100, 116, 139, 0.10) 45%,
    rgba(100, 116, 139, 0.18) 50%,
    rgba(100, 116, 139, 0.10) 55%,
    transparent 100%
  );
}

@keyframes mldr-shimmer {
  100% { transform: translateX(100%); }
}

/* Header */
.mldr-head { margin-bottom: 26px; }
.mldr-title { height: 32px; width: min(280px, 60%); border-radius: 9px; }
.mldr-sub   { height: 15px; width: min(200px, 45%); border-radius: 7px; margin-top: 14px; opacity: 0.7; }

/* KPI card row */
.mldr-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
  gap: 16px;
  margin-bottom: 22px;
}
.mldr-card { height: 118px; }

/* Wide section blocks */
.mldr-section { height: 200px; margin-bottom: 18px; }
.mldr-section.tall { height: 260px; }

/* Centred status pill */
.mldr-status {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: 30px;
  color: var(--text-muted, #64748b);
  font-size: 0.85rem;
  font-weight: 600;
  letter-spacing: 0.01em;
}
.mldr-spinner {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  border: 2px solid var(--border-subtle, rgba(148, 163, 184, 0.25));
  border-top-color: var(--accent-emerald, #10b981);
  animation: mldr-spin 0.7s linear infinite;
}
@keyframes mldr-spin { to { transform: rotate(360deg); } }

@media (prefers-reduced-motion: reduce) {
  .mldr-sk::after, .mldr-spinner, .mldr { animation: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/ModuleLoader.css"],"names":[],"mappings":"AAAA;;kGAEkG;;AAElG;EACE,gBAAgB;EAChB,uBAAuB;EACvB,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;AAEA,yDAAyD;AACzD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kDAAkD;EAClD,iEAAiE;EACjE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,4BAA4B;EAC5B;;;;;;;GAOC;EACD,iDAAiD;AACnD;AACA;EACE;;;;;;;GAOC;AACH;;AAEA;EACE,OAAO,2BAA2B,EAAE;AACtC;;AAEA,WAAW;AACX,aAAa,mBAAmB,EAAE;AAClC,cAAc,YAAY,EAAE,sBAAsB,EAAE,kBAAkB,EAAE;AACxE,cAAc,YAAY,EAAE,sBAAsB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,YAAY,EAAE;;AAExG,iBAAiB;AACjB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;AACA,aAAa,aAAa,EAAE;;AAE5B,wBAAwB;AACxB,gBAAgB,aAAa,EAAE,mBAAmB,EAAE;AACpD,qBAAqB,aAAa,EAAE;;AAEpC,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iEAAiE;EACjE,gDAAgD;EAChD,yCAAyC;AAC3C;AACA,uBAAuB,KAAK,yBAAyB,EAAE,EAAE;;AAEzD;EACE,wCAAwC,eAAe,EAAE;AAC3D","sourcesContent":["/* Skeleton shown while a lazy-loaded dashboard chunk downloads (shell Suspense fallback).\n   Mimics a dashboard's layout — title, KPI cards, section blocks — with a shimmer sweep, so\n   opening a module fades into placeholder \"sections\" instead of a bare \"Loading...\" text flash. */\n\n.mldr {\n  min-height: 100%;\n  padding: 28px 24px 40px;\n  background: var(--bg-primary, #080c14);\n  animation: mldr-fade 0.25s ease;\n}\n\n@keyframes mldr-fade {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n/* Shimmer block base — every placeholder is a .mldr-sk */\n.mldr-sk {\n  position: relative;\n  overflow: hidden;\n  background: var(--bg-card, rgba(15, 23, 42, 0.45));\n  border: 1px solid var(--border-subtle, rgba(255, 255, 255, 0.04));\n  border-radius: 14px;\n}\n.mldr-sk::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  transform: translateX(-100%);\n  background: linear-gradient(\n    90deg,\n    transparent 0%,\n    rgba(148, 163, 184, 0.10) 45%,\n    rgba(148, 163, 184, 0.16) 50%,\n    rgba(148, 163, 184, 0.10) 55%,\n    transparent 100%\n  );\n  animation: mldr-shimmer 1.6s ease-in-out infinite;\n}\n[data-theme=\"light\"] .mldr-sk::after {\n  background: linear-gradient(\n    90deg,\n    transparent 0%,\n    rgba(100, 116, 139, 0.10) 45%,\n    rgba(100, 116, 139, 0.18) 50%,\n    rgba(100, 116, 139, 0.10) 55%,\n    transparent 100%\n  );\n}\n\n@keyframes mldr-shimmer {\n  100% { transform: translateX(100%); }\n}\n\n/* Header */\n.mldr-head { margin-bottom: 26px; }\n.mldr-title { height: 32px; width: min(280px, 60%); border-radius: 9px; }\n.mldr-sub   { height: 15px; width: min(200px, 45%); border-radius: 7px; margin-top: 14px; opacity: 0.7; }\n\n/* KPI card row */\n.mldr-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));\n  gap: 16px;\n  margin-bottom: 22px;\n}\n.mldr-card { height: 118px; }\n\n/* Wide section blocks */\n.mldr-section { height: 200px; margin-bottom: 18px; }\n.mldr-section.tall { height: 260px; }\n\n/* Centred status pill */\n.mldr-status {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  margin-top: 30px;\n  color: var(--text-muted, #64748b);\n  font-size: 0.85rem;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n}\n.mldr-spinner {\n  width: 15px;\n  height: 15px;\n  border-radius: 50%;\n  border: 2px solid var(--border-subtle, rgba(148, 163, 184, 0.25));\n  border-top-color: var(--accent-emerald, #10b981);\n  animation: mldr-spin 0.7s linear infinite;\n}\n@keyframes mldr-spin { to { transform: rotate(360deg); } }\n\n@media (prefers-reduced-motion: reduce) {\n  .mldr-sk::after, .mldr-spinner, .mldr { animation: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
